import { AUTH_BASE_URL } from "../constants/constants";
import { sendRequest } from "../utils/sendAPI";
import { getToken } from "./authApi";

export const getBookingReport = async ({ year, month }) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const params = new URLSearchParams({});
    if (year) params.append("year", year);
    if (month) params.append("month", month);

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/reports/booking?${params.toString()}`,
      method: "GET",
      token: token,
    });

    return res;
  } catch (err) {
    console.error("Error fetching booking report:", err);
    throw err;
  }
};

/* Total New Customer And Top 5 Customers*/
export const getCustomerReport = async ({ year, month }) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const params = new URLSearchParams({});
    if (year) params.append("year", year);
    if (month) params.append("month", month);

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/reports/customer?${params.toString()}`,
      method: "GET",
      token: token,
    });

    return res;
  } catch (err) {
    console.error("Error fetching booking report:", err);
    throw err;
  }
};
